/* unplugin-vue-components disabled */import script from "./step-4.vue?vue&type=script&setup=true&lang=js"
export * from "./step-4.vue?vue&type=script&setup=true&lang=js"

import "./step-4.vue?vue&type=style&index=0&id=42dc4a22&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_do6gl7biqum247ry4qofa4hfiq/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42dc4a22"]])

export default __exports__